<div class="notfound">
    <div class="notfound-404">
        <h1>4<span>0</span>4</h1>
    </div>
    <h2>The page you requested could not be found</h2>
    <form class="notfound-search">
        <!-- <input type="text" placeholder="Search...">
        <button type="button"><span></span></button> -->
    </form>
</div>
